import PropTypes from "prop-types";

export const vehicleType = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  currentZone: PropTypes.node,
  data: PropTypes.shape({
    health: PropTypes.number,
  }),
  model: PropTypes.node,
  status: PropTypes.node,
  components: PropTypes.array.isRequired,
});

export const componentType = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  health: PropTypes.number,
  model: PropTypes.string,
  chargePercent: PropTypes.number,
  serial: PropTypes.string,
});

export const activeFleetType = PropTypes.shape({
  name: PropTypes.string,
  url: PropTypes.string,
});

// Int values in css-in-js styles are automatically converted to pixels
// Strings are necessary for other types of units (%, vh, etc)
export const cssValueType = PropTypes.oneOfType([PropTypes.string, PropTypes.number]);

export const fleetHandlerType = PropTypes.shape({
  fleets: PropTypes.object.isRequired,
  activeFleet: activeFleetType.isRequired,
  getFleets: PropTypes.func.isRequired,
});
